// Booking Service Cart Vue Component
// This component handles the cart functionality for service booking

function createServiceCartComponent(categoriesData, productsData, isAuthenticated) {
    return {
        data() {
            return {
                category: categoriesData,
                product: productsData,
                cart: {},
                guestNum: 1
            };
        },
        computed: {
            cartTotalQuantity() {
                let total = 0;
                for (let key in this.cart) {
                    total += this.cart[key];
                }
                return total;
            },
            cartTotalMoney() {
                let total = 0;
                for (let key in this.cart) {
                    const product = this.product.find(p => p.productId === key);
                    if (product) {
                        total += product.price * this.cart[key];
                    }
                }
                return 'RM' + total.toFixed(2);
            }
        },
        methods: {
            addGuestNum(delta) {
                this.guestNum = Math.max(1, this.guestNum + delta);
            },
            addCart(productId, delta) {
                if (!this.cart[productId]) {
                    this.cart[productId] = 0;
                }
                this.cart[productId] = Math.max(0, this.cart[productId] + delta);
                if (this.cart[productId] === 0) {
                    delete this.cart[productId];
                }
            },
            getQuantity(productId) {
                return this.cart[productId] || 0;
            },
            servicesCategoryNum(categoryId) {
                return this.product.filter(p => p.categoryId === categoryId).length;
            },
            goBuy() {
                // Validation 1: Check if cart is empty
                if (this.cartTotalQuantity <= 0) {
                    if (typeof rawAlert === 'function') {
                        rawAlert("Please add at least one service to proceed.", "Attention");
                    } else {
                        alert("Please add at least one service to proceed.");
                    }
                    return;
                }
                
                // Validation 2: Check if services are less than guests (from old code)
                if (this.guestNum > this.cartTotalQuantity) {
                    if (typeof rawAlert === 'function') {
                        rawAlert("Service must be = or > than total guest.", "Attention");
                    } else {
                        alert("Service must be = or > than total guest.");
                    }
                    return;
                }
                
                // Validation 3: Check if total services exceed number of guests
                if (this.cartTotalQuantity > this.guestNum) {
                    if (typeof rawAlert === 'function') {
                        rawAlert(
                            "Please add one more guest or remove a treatment to proceed. Thank you!",
                            "Attention"
                        );
                    } else {
                        alert("Please add one more guest or remove a treatment to proceed. Thank you!");
                    }
                    return;
                }
                
                // Validation 4: Check if outlet ID exists
                const outletId = document.getElementById('outletId');
                const bType = document.getElementById('bType');
                
                if (!outletId || !outletId.value) {
                    if (typeof rawAlert === 'function') {
                        rawAlert("Please select an outlet first.", "Outlet Required");
                    } else {
                        alert("Please select an outlet first.");
                    }
                    return;
                }
                
                // Save cart data to sessionStorage for the next step
                try {
                    const cartData = {
                        cart: this.cart,
                        guestNum: this.guestNum,
                        cartTotalQuantity: this.cartTotalQuantity,
                        cartTotalMoney: this.cartTotalMoney,
                        timestamp: Date.now()
                    };
                    sessionStorage.setItem('bookingCart', JSON.stringify(cartData));
                } catch (e) {
                    console.warn('Could not save cart to sessionStorage:', e);
                }
                
                // Navigate to next step
                const outletIdValue = outletId.value;
                const bTypeValue = bType ? bType.value : '1';
                window.location.href = `/booking/selecttime?type=${bTypeValue}&outletId=${outletIdValue}`;
            }
        }
    };
}

// Make it available globally
if (typeof window !== 'undefined') {
    window.createServiceCartComponent = createServiceCartComponent;
}

